module.exports = __webpack_public_path__ + "img/20211114.e8f758db.png";